<template>
    <footer class="footer">
        <div class="wrapper">
            <div class="footer__nav-container">
                <FooterMenu />
            </div>
            <div class="footer-separator" />
            <div class="footer__common-info">
                <a
                    v-for="({link, title}, index) in footerLinks.firstGroup"
                    :key="`${index}-${link}`"
                    class="footer__common-info__link"
                    :href="link"
                    target="_blank"
                    rel="noopener noreferrer"
                    v-html="title"
                />
            </div>
            <div class="footer__common-info">
                <p class="footer__text">
                    Уставный капитал&nbsp;&mdash; 933&nbsp;567 570,00&nbsp;
                    руб., дата изменения величины уставного капитала: 29.10.2015
                </p>
                <a
                    v-for="({link, title}, index) in footerLinks.secondGroup"
                    :key="`${index}-${link}`"
                    class="footer__common-info__link"
                    :href="link"
                    target="_blank"
                    rel="noopener noreferrer"
                    v-html="title"
                />
            </div>
            <div class="footer__common-info mb-16">
                <a
                    v-for="({link, title}, index) in footerLinks.thirdGroup"
                    :key="`${index}-${link}`"
                    class="footer__common-info__link"
                    :href="link"
                    target="_blank"
                    rel="noopener noreferrer"
                    v-html="title"
                />
            </div>
            <p class="footer__text mt-16 mb-16">
                В&nbsp;целях улучшения сервисов и&nbsp;повышения удобства пользования сайтом банк
                &laquo;Центр-инвест&raquo; использует файлы cookie. Продолжая использовать наш сайт,
                вы&nbsp;принимаете условия
                <a
                    href="https://www.centrinvest.ru/media/about/processing__agreement.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="footer__common-info__link footer__common-info__link--without-margin text-underline"
                >
                    Положения об&nbsp;обработке и защите персональных данных.
                </a>
                Если вы&nbsp;не&nbsp;хотите, чтобы ваши пользовательские
                данные обрабатывались, отключите cookie в&nbsp;настройках браузера.
            </p>
            <p class="footer__text">
                Copyright &copy;&nbsp;1997-{{ currentYear }}, ПАО КБ&nbsp;
                &laquo;Центр-инвест&raquo;, 344000, г.&nbsp;Ростов-на-Дону, пр. Соколова, 62
            </p>
            <p class="footer__text">
                Design&amp;Support&nbsp;&copy;
                <a
                    class="footer__common-info__link"
                    href="https://cinet.ru/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    &laquo;Центр-Интернет&raquo;
                </a>
            </p>
        </div>
    </footer>
</template>

<script>
import {defineComponent} from 'vue';

import FooterMenu from '@/components/Sections/Footer/FooterMenu';
import {footerLinks} from '@/core/models/common/FooterModel';

export default defineComponent({
    name: 'TheFooter',
    components: {
        FooterMenu,
    },
    setup() {
        return {
            footerLinks,
            currentYear: new Date().getFullYear(),
        };
    },
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common/footer/footer';
</style>
